import { render } from "./V5StyleBottom.vue?vue&type=template&id=632a129c&scoped=true"
import script from "./V5StyleBottom.vue?vue&type=script&lang=js"
export * from "./V5StyleBottom.vue?vue&type=script&lang=js"

import "./V5StyleBottom.vue?vue&type=style&index=0&id=632a129c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632a129c"]])

export default __exports__